<template>
    <div>
    </div>
</template>

<script>
  import { register, login, bonus, payment, useragent } from '@/api/crm';

  export default {
    name: 'CRMIntegration',
    props: {
      authToken: {
        type: String,
      },
      jwtToken: {
        type: String,
      },
      userId: {
        type: Number,
      },
      crmUrl: {
        type: String,
      },
    },
    methods: {
      loggedIn(userAgent) {
        return new Promise((resolve, reject) => {
          login(this.crmUrl, this.jwtToken, this.userId, userAgent).then((response) => {
            if (!response.data.Success) {
              reject(response.data.Errors);
              return;
            }
            resolve(response.data.Data);
          }).catch(reject);
        });
      },
      registered(userAgent, urlReferer, note) {
        return new Promise((resolve, reject) => {
          register(this.crmUrl, this.jwtToken, this.userId, userAgent, urlReferer, note).then((response) => {
            if (!response.data.Success) {
              reject(response.data.Errors);
              return;
            }
            resolve(response.data.Data);
          }).catch(reject);
        });
      },
      bonusConsumed(amount, bonusCode, bonusId, bonusTurnedReal, currency, exchangeRate, lockedAmount, product, requiredWageringAmount, status, type, userBonusId) {
        return new Promise((resolve, reject) => {
          bonus(this.crmUrl, this.jwtToken, this.userId, amount, bonusCode, bonusId, bonusTurnedReal, currency, exchangeRate, lockedAmount, product, requiredWageringAmount, status, type, userBonusId).then((response) => {
            if (!response.data.Success) {
              reject(response.data.Errors);
              return;
            }
            resolve(response.data.Data);
          }).catch(reject);
        });
      },
      paymentMade(amount, bonusCode, currency, depositCount, exchangeRate, feeAmount, note, paymentId, status, type, vendorId, withdrawCount) {
        return new Promise((resolve, reject) => {
          payment(this.crmUrl, this.jwtToken, this.userId, amount, bonusCode, currency, depositCount, exchangeRate, feeAmount, note, paymentId, status, type, vendorId, withdrawCount).then((response) => {
            if (!response.data.Success) {
              reject(response.data.Errors);
              return;
            }
            resolve(response.data.Data);
          }).catch(reject);
        });
      },
      updateUserAgent(userAgent) {
        return new Promise((resolve, reject) => {
          useragent(this.crmUrl, this.jwtToken, this.userId, this.getCurrentTimestampWithFormat(), userAgent).then((response) => {
            if (!response.data.Success) {
              reject(response.data.Errors);
              return;
            }
            resolve(response.data.Data);
          }).catch(reject);
        });
      },
      getCurrentTimestampWithFormat() {
        const date = new Date();
        const str = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " +  date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();

        return str;
      },
    },
  };
</script>

<style>

</style>
